__webpack_require__.p = "/vsnet-static/";